.icon-comment,.icon-comment .icon-wrapper{position:relative}.icon-comment .icon-wrapper .top-right-icon{font-size:7px;position:absolute;top:0;right:-2px;color:#258cfd}
/*# sourceMappingURL=scheduler-reports-table-actions.component-7BKGHX5T.css.map */
